import React from 'react';
import PropTypes from 'prop-types';
var StepWrapper = function StepWrapper(_ref) {
  var stepClassNames = _ref.stepClassNames,
    children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: "step ".concat(stepClassNames)
  }, /*#__PURE__*/React.createElement("div", {
    className: "step__wrapper"
  }, children));
};
StepWrapper.propTypes = {
  stepClassNames: PropTypes.string,
  children: PropTypes.node.isRequired
};
StepWrapper.defaultProps = {
  stepClassNames: ''
};
export default StepWrapper;